import { Button, Kind } from '@thanx/uikit/button'
import { useStyletron } from '@thanx/uikit/theme'
import palette from 'constants/palette'
import React from 'react'

type Props = {
  count: number
  onAcceptAll: () => void
  onRejectAll: () => void
}

const AiSuggestionsBanner: React.FC<Props> = ({
  count,
  onAcceptAll,
  onRejectAll,
}) => {
  const [css] = useStyletron()

  return (
    <div
      data-testid="accept-all-banner"
      className={css({
        position: 'fixed',
        bottom: '72px',
        left: '50%',
        transform: 'translateX(-50%)',
        backgroundColor: '#FFFFFF',
        borderRadius: '4px',
        padding: '16px 24px',
        display: 'flex',
        alignItems: 'center',
        gap: '48px',
        zIndex: 100,
        boxShadow: '0px 8px 24px rgba(54, 66, 78, 0.2)',
      })}
    >
      <span
        className={css({
          fontWeight: 400,
          color: palette.grey90,
          fontSize: '16px',
          lineHeight: '24px',
          letterSpacing: '0.25px',
          flexShrink: 0,
        })}
      >
        {count} {count === 1 ? 'suggestion' : 'suggestions'} awaiting review
      </span>
      <div
        className={css({
          display: 'flex',
          gap: '16px',
          flexShrink: 0,
        })}
      >
        <Button
          kind={Kind.SECONDARY}
          onClick={onRejectAll}
          data-testid="reject-all-btn"
        >
          Dismiss all
        </Button>
        <Button onClick={onAcceptAll} data-testid="accept-all-btn">
          Apply all
        </Button>
      </div>
    </div>
  )
}

export default AiSuggestionsBanner
